import { render, staticRenderFns } from "./ia.component.html?vue&type=template&id=485cbf93&scoped=true&"
import script from "./ia.component.ts?vue&type=script&lang=ts&"
export * from "./ia.component.ts?vue&type=script&lang=ts&"
import style0 from "./ia.component.scss?vue&type=style&index=0&id=485cbf93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cbf93",
  null
  
)

export default component.exports